import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	header: 'How much would you like to send?',
	description:
		'You can enter this amount in the currency you’ve selected or in the currency of the account you’re sending the money from (typically pounds sterling). For example, if you’ve got an invoice in euros, you’ll most likely want to enter the amount in euros.',
	invalidValidationMsg: 'invalidValidationMsg',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
